import moment from "moment";
import { useQuery } from "@apollo/react-hooks";
import { MY_TIMESHEET_GET_GROUPED_BY_USERS_LIST } from "my-timesheet/graphql";

type UseMyTimesheetGroupedByUsersListParams = {
  page: number;
  pageSize: number;
  startTime?: string | Date;
  endTime?: string | Date;
  roleFilters?: string[];
  role?: string;
};

export const useMyTimesheetGroupedByUsersList = ({
  page,
  pageSize,
  startTime,
  endTime,
  roleFilters,
  role,
}: UseMyTimesheetGroupedByUsersListParams) => {
  const { data, loading, error, refetch } = useQuery(
    MY_TIMESHEET_GET_GROUPED_BY_USERS_LIST,
    {
      fetchPolicy: "cache-and-network",
      variables: { page, pageSize, startTime, endTime, role, roleFilters },
    },
  );

  const list = data?.groupedByUsersMySheetList || [];
  const rows = list?.rows || [];

  type RowType = {
    startTime?: string | Date;
    endTime?: string | Date;
    [key: string]: any;
  };

  const parsedRows = rows.map((row: RowType) => {
    let duration = "00:00";
    if (row?.startTime && row.endTime) {
      duration = moment
        .utc(
          new Date(row.endTime).getTime() - new Date(row.startTime).getTime(),
        )
        .format("HH:mm");
    }
    return {
      ...row,
      startTime: row.startTime ? moment(row.startTime).format("HH:mm") : "",
      endTime: row.endTime ? moment(row.endTime).format("HH:mm") : "",
      duration,
    };
  });

  const newData = {
    ...list,
    rows: parsedRows,
  };

  return {
    data: newData,
    loading,
    error,
    refetch,
  };
};

export default useMyTimesheetGroupedByUsersList;
